@if (isLoading$ | async) {
  <div class="loading-indicator">
    <div class="spinner"></div>
    <span class="loading-text">กำลังโหลด...</span>
  </div>
}
